/**
 * Trạng thái của database
 * nvtoan2 30/07/2024
 */
export default {
  /// <summary>
  /// Hiển thị trên giao diện người dùng
  /// </summary>
  ShowInClient: 1,
  /// <summary>
  /// Không hiển thị trên giao diện người dùng (là trường hợp người dùng đã xóa)
  /// </summary>
  Deleted: 0,
  /// <summary>
  /// Hiển thị trên giao diện người dùng danh sách dữ liệu không sử dụng
  /// </summary>
  ShowInClientNotWorking: 3,
  /// <summary>
  /// Đang phục hồi
  /// </summary>
  Restoring: 2,
  /// <summary>
  /// dữ liệu lỗi
  /// </summary>
  Error: 4,
  /// <summary>
  /// Đang tạo dữ liệu
  /// </summary>
  CreateData: 5,
  /// <summary>
  /// Đang chuyển đổi
  /// </summary>
  Converting: 6,
  /// <summary>
  /// Dữ liệu lỗi khi chuyển đổi
  /// </summary>
  ConvertError: 7,
};